import { Component, Inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";
import { GuiService } from 'src/app/services/gui.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-workout-program-detail',
  templateUrl: './workout-program-detail.component.html',
  styleUrls: ['./workout-program-detail.component.scss']
})
export class WorkoutProgramDetailComponent implements OnInit {
  @Input() program: any;
  @Input() colorClass: any;
  environment = environment.baseURL.workout_programs;
  spinner: boolean = false;

  constructor(public guiService: GuiService, public translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>, private restService: RestService) {
    this.program = data.program;
  }

  ngOnInit() {
    setTimeout(() => {
      localStorage.getItem('tourWorkoutProgramDetailShowed') ? null : this.startTour();
    }, 500);

  }

  changeProgram() {
    if (this.guiService.userLogged.workoutInfo) {
      this.guiService.userLogged.workoutInfo.currentProgram = this.program.id;
      this.guiService.reloadProgram = true;
      setTimeout(() => {
        this.closeModal(true);
      }, 500);
    } else {
      this.selectProgram();
    }
  }

  closeModal(redirect?) {
    this.dialogRef.close({ dismissed: true, redirect: redirect ? 'goHome' : null });
  }

  selectProgram(){
    const params = {
      userId: this.guiService.userLogged.user.id,
      currentProgram: this.program.id
    }
    this.spinner = true;
    this.restService.postService('node', '/init-workout-program', params).subscribe((ris)=>{
      this.guiService.userLogged.workoutInfo = ris;
      this.spinner = false;
      this.closeModal();
      this.guiService.goTo('main/home');
    })
  }

  startTour(): void {
    localStorage.setItem('tourWorkoutProgramDetailShowed', 'true')

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.select-program-btn', popover: { title: this.translate.instant('TUTORIALS.workout-programs.startAnytimeTitle'), description: this.translate.instant('TUTORIALS.workout-programs.startAnytimeDescription'), side: 'bottom'} },
      ]
    });

    driverObj.drive();
  }

}
